import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import App from "@/App";
import { queryClient } from "@/lib/query-client";
import { registreerServiceWorker } from "@/lib/push";
import { installeerToetsToastDedupe } from "@/lib/toetsWeigering";
import "@/i18n";
import "@/styles/globals.css";

// Pushmeldingen (ronde E): de service worker staat los van de
// SPA-bundel en doet niets tot een apparaat zich abonneert via het
// instellingenblok op de profielpagina. Fire-and-forget.
void registreerServiceWorker();

// Toetsaccount (sessie 77): één melding per weigering, ook als het
// scherm zelf nog een fouttoast toont.
installeerToetsToastDedupe();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
